import React, { useMemo } from 'react';

import { minutesToParts } from 'utils/Helpers';

import Pill from 'components/Misc/Pill';
import { Title } from 'components/Misc/Typography';

import { useExamStudentStore } from 'store/exam/useExamStudentStore';

const Information = () => {
	// Use exam's student store
	const [exam, subject] = useExamStudentStore(state => [state.exam, state.subject]);

	// Get exam's duration in usable format
	const duration = useMemo(() => minutesToParts(exam.duration), [exam.duration]);
	
	return (
		<div className="flex items-center">
			<Title
				title={exam.titlePublic}
				subtitle={subject?.title}
				className="text-xl flex-1"
			/>

			{/* Display duration if assigned */}
			<Pill
				name={`${duration.days}d : ${duration.hours}h : ${duration.minutes}m`}
				theme="informative"
				className="ml-4"
			/>
		</div>
	);
};

export default Information;